var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AgHeader'),_c('router-view'),(this.$store.state.loading)?_c('div',{staticClass:"loading-wrap"},[_c('a-spin',{staticClass:"loading",attrs:{"size":"large","tip":"数据加载中..."}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }